import { AlertTriangle, X } from "lucide-react";
import { useEffect, useState } from "react";
import { SERVICE_UNAVAILABLE_EVENT } from "@/services/api";

const AUTO_HIDE_MS = 8000;

export function ServiceStatusBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let hideTimer: number | undefined;

    const onUnavailable = () => {
      setVisible(true);
      if (hideTimer) window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => setVisible(false), AUTO_HIDE_MS);
    };

    window.addEventListener(SERVICE_UNAVAILABLE_EVENT, onUnavailable);
    return () => {
      window.removeEventListener(SERVICE_UNAVAILABLE_EVENT, onUnavailable);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      role="alert"
      className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] max-w-md w-[calc(100%-2rem)]
        bg-amber-500/95 text-amber-950 rounded-xl shadow-lg border border-amber-600
        flex items-start gap-3 px-4 py-3"
    >
      <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
      <div className="flex-1 text-sm leading-relaxed">
        <p className="font-semibold">Service temporarily unavailable</p>
        <p className="text-amber-900">
          We're having trouble reaching the server. Please wait a moment and try again.
        </p>
      </div>
      <button
        onClick={() => setVisible(false)}
        className="flex-shrink-0 rounded-md hover:bg-amber-600/30 p-1 transition-colors"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
